export default "__VITE_ASSET__cf1f01ea__"